module.exports = __webpack_public_path__ + "fonts/Inter-300-greek39.4a4b49c.woff2";